import B2ChatClient from '@client-sdk';
import { allBotAccounts } from '@src/reducers/allBotAccounts';
import { isErrorPayload } from '@src/services/service';
import { BotAccount } from '@src/types';
import { B2ChatAPI } from '@types-api';
import { call, delay, put, takeLeading } from 'redux-saga/effects';

function* fetchAllBotAccountsSaga() {
  try {
    const response: B2ChatAPI.Response<BotAccount[]> = yield call(
      B2ChatClient.resources.botServices.actions.listUserBotAccounts
    );

    if (response.error) {
      throw response.error;
    }

    yield put(allBotAccounts.fetchAllBotAccountsSuccess(response.data));
  } catch (error) {
    if (isErrorPayload(error)) {
      yield put(allBotAccounts.fetchAllBotAccountsFailure(error));
    } else {
      yield put(
        allBotAccounts.fetchAllBotAccountsFailure({
          errorCode: 'UNKNOWN',
          details: (error as Error).message,
        })
      );
    }
  } finally {
    yield delay(2000);
    yield put(allBotAccounts.fetchAllBotAccountsFulfill());
  }
}

function* botAccounts() {
  yield takeLeading(
    allBotAccounts.fetchAllBotAccounts,
    fetchAllBotAccountsSaga
  );
}

export default botAccounts;
